import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { ProductCard } from "../components/ProductCard";
import { ProductListNav } from "../components/ProductListNav";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader chain via PageSkeleton, which is typed with mutable
// reactivated props (see PageSkeleton).
export const Template = (
    props: templates.ProductListPageTemplate,
): React.JSX.Element => {
    const { page, categories, link_banners } = props;
    const alignment = page.hero_alignment;

    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-full-width">
                <div
                    className="hero product-list-hero l-full-width product-list-hero--tempurpedic"
                    style={
                        props.hero_image_url
                            ? {
                                  backgroundImage: `url(${props.hero_image_url})`,
                              }
                            : undefined
                    }
                >
                    <div className="product-list-hero__content l-capped-width">
                        {props.hero_badge_image_url && (
                            <div className="product-list-hero-badge">
                                <div
                                    className={`product-list-hero-badge__image-container${
                                        alignment
                                            ? ` product-list-hero-badge__image-container--${alignment}`
                                            : ""
                                    }`}
                                >
                                    <img
                                        src={props.hero_badge_image_url}
                                        alt={props.hero_badge_image_alt}
                                        className="product-list-hero-badge__image responsive-img"
                                    />
                                </div>
                            </div>
                        )}
                        <div
                            className={`product-list-hero__copy${
                                alignment
                                    ? ` product-list-hero__copy--${alignment}`
                                    : ""
                            } product-list-hero__copy--tempurpedic`}
                        >
                            {page.hero_category_title && (
                                <div className="product-list-hero__category product-list-hero__category--tempurpedic">
                                    {page.hero_category_title}
                                </div>
                            )}
                            {page.hero_title && (
                                <div className="product-list-hero__title product-list-hero__title--tempurpedic">
                                    {page.hero_title}
                                </div>
                            )}
                            {page.hero_description && (
                                <div className="product-list-hero__description product-list-hero__description--tempurpedic">
                                    {page.hero_description}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="product-lists u-margin-bottom--xl">
                <ProductListNav categories={categories} />

                {categories.map((category, i) => (
                    <div
                        key={i}
                        className="product-list product-list--tempurpedic"
                        id={category.title}
                    >
                        <div className="product-list__background l-capped-width">
                            <div className="product-list__header product-list__header--tempurpedic">
                                <div className="product-list__header-copy product-list__header-copy--tempurpedic">
                                    <div className="product-list__title">
                                        {category.title}
                                    </div>
                                    <div
                                        className="product-list__description"
                                        dangerouslySetInnerHTML={{
                                            __html: category.description_html,
                                        }}
                                    />
                                </div>
                                {category.hero_image_url && (
                                    <img
                                        src={category.hero_image_url}
                                        alt={category.hero_image_alt}
                                        className="product-list__header-image responsive-img"
                                        loading="lazy"
                                        decoding="async"
                                    />
                                )}
                            </div>
                            {category.products.length > 0 && (
                                <div className="product-list__content u-flex-container">
                                    {category.products.map((product) => (
                                        <ProductCard
                                            key={product.id}
                                            product={product}
                                            className="product-list__card"
                                        />
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                ))}

                <div className="product-list-callout u-margin-bottom--xl">
                    {link_banners.map((banner, i) => (
                        <div key={i} className="product-list-link-banner">
                            <img
                                src={banner.image_url}
                                alt={banner.image_alt}
                                className="product-list-link-banner__image responsive-img"
                                loading="lazy"
                                decoding="async"
                            />
                            <div className="product-list-link-banner__copy l-capped-width">
                                <div className="product-list-link-banner__title">
                                    {banner.text}
                                </div>
                                {banner.page_href && (
                                    <a
                                        href={banner.page_href}
                                        className="button button--primary-congress-blue product-list-link-banner__button"
                                    >
                                        Shop {banner.page_title}
                                    </a>
                                )}
                                {banner.external_link && (
                                    <a
                                        href={banner.external_link}
                                        className="button button--primary-congress-blue product-list-link-banner__button"
                                    >
                                        Shop Now
                                    </a>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </PageSkeleton>
    );
};
